/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-11-18 08:46:07
 * @LastEditors: jyf
 * @LastEditTime: 2022-12-08 17:47:08
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace ReceivableApi {

    /**
     * 新增应收
     */
    export var Add = (body: AddReceivableVM): Promise<any> => {
        return Post(`/msls/Receivable/Add`, body);
    };
    /**
     * 查询应收列表
     */
    export var GetList = (body: GetReceivableListPayload): Promise<any> => {
        return Get(`/msls/Receivable/GetList?${qs.stringify(body)}`, {});
    };
    /**
     * 编辑应收
     */
    export var Edit = (id: string, body: EditReceivableVM): Promise<any> => {
        return Put(`/msls/Receivable/Edit/${id}`, body);
    };
    /**
      * 查询应收列表导出
      */
    export var GetListExport = (body: GetReceivableListPayload): Promise<any> => {
        return Download(`/msls/Receivable/Export?${qs.stringify(body)}`, {});
    };
    /**
     * 
创建应收账单
     */
    export var AddReceivableBill = (body: AddReceivableBillVM): Promise<any> => {
        return Post(`/msls/ReceivableBill/Add`, body);
    };
    /**
     * 账单列表
     */
    export var GetReceivableBillList = (body: GetReceivableBillListPayload): Promise<any> => {
        return Get(`/msls/ReceivableBill/GetList?${qs.stringify(body)}`, {});
    };
    
    /**
     * 获取运单费用
     */
    export var GetCarrierOrderList = (body: GetCarrierOrderListPayload): Promise<any> => {
        return Get(`/msls/ReceivableBill/GetCarrierOrderList?${qs.stringify(body)}`, {});
    };
     /**
     * 运单费用导出
     */
      export var GetCarrierOrderListExport = (body: GetCarrierOrderListPayload): Promise<any> => {
        return Download(`/msls/ReceivableBill/GetCarrierOrderListExport?${qs.stringify(body)}`, {});
    };
    /**
     * 获取应收账单详情
     */
     export var GetDetail = (id: string): Promise<any> => {
        return Get(`/msls/ReceivableBill/Get/${id}`, {});
    };
    /**
     * 账单列表导出
     */
       export var GetReceivableExportlist = (body: GetReceivableBillListPayload): Promise<any> => {
        return Download(`/msls/ReceivableBill/Exportlist?${qs.stringify(body)}`, {});
    };
    /**
     * 审核通过账单
     */
    export var AuditPass = (billId: string): Promise<any> => {
        return Put(`/msls/ReceivableBill/AuditPass/${billId}`, {})
    };
    /**
     * 删除运单费用
     */
     export var DelCoReceivable = (body: any): Promise<any> => {
        return Put(`/msls/ReceivableBill/DelCoReceivable`, body)
    };
    /**
     * 保存账单
     */
    export var SaveBill = (body: SaveReceivableBillVM): Promise<any> => {
        return Post(`/msls/ReceivableBill/SaveBill/SaveBill`, body);
    };
    /**
     * 添加应收账单费用
     */
    export var AddBillExpense = (body: AddReceivableBillExpenseVM): Promise<any> => {
        return Post(`/msls/ReceivableBill/AddBillExpense`, body);
    };
    /**
     * 获取账单费用列表
     */
    export var GetBillExpenseList = (billId: string): Promise<any> => {
        return Get(`/msls/ReceivableBill/GetBillExpenseList/${billId}`, {})
    };
    /**
     * 删除账单费用
     */
    export var DeleteBillExpense = (id: string): Promise<any> => {
        return Delete(`/msls/ReceivableBill/DeleteBillExpense/${id}`, {})
    };
    /**
     * 删除账单
     */
     export var DeleteBill = (billId: string): Promise<any> => {
        return Put(`/msls/ReceivableBill/DeleteBill/${billId}`, {})
    };
    /**
     * 查询待对账列表
     */
     export var GetReceivableList = (body: GetReceivableListPayload): Promise<any> => {
        return Get(`/msls/ReceivableBill/GetReceivableList?${qs.stringify(body)}`, {});
    };
  
    /**
     *   添加待对账的应付费用至 账单中
     */
    export var AddReceivableToBill = (body:any): Promise<any> => {
        return Put(`/msls/ReceivableBill/AddReceivableToBill`, body)
    };
    
    
    export interface ReceCarrierOrderListItemVM{
        index?:number;
          /**
       * 运单id
       */
      id?: string | null;
      /**
       * 运单编号
       */
      carrierOrderCode?: string | null;
      /**
       * 装运单号
       */
      shipOrderNo?: string | null;
      /**
       * 原装运单号
       */
      relatedShipOrderNo?: string | null;
      /**
       * 收货地址
       */
      arrivalAddress?: string | null;
      /**
       * 实际发货时间
       */
      realDeliveryTime?: string;
      /**
       * 含税金额
       */
      includeTaxAmount?: number | null;
      /**
       * 油卡金额
       */
      oilCardAmount?: number | null;
      /**
       * 客诉金额
       */
      customerComplaintAmount?: number | null;
      /**
       * 雨布金额
       */
      waterproofAmount?: number | null;
      /**
       * 其他金额
       */
      otherAmount?: number | null;
      /**
       * 费用合计
       */
      totalAmount?: number | null;
      /**
       * 订单集合
       */
      orderList?:any
    }
    /**
 * 添加应收
 */
    export interface AddReceivableVM {
        /**
         * 运单id
         */
        carrierOrderId?: string | null;
        /**
         * 费用类型
         */
        expenseType?: string | null;
        /**
         * 金额
         */
        amount?: number | null;
        /**
         * 费用说明
         */
        expenseExplain?: string | null;
    };
    /**
     * 获取应收列表数据
     */
    export interface GetReceivableListPayload {
        /**
         * 审核状态Available values : 0, 1, 2, 3
         */
        status?: number | string;
        /**
         * 费用类型
         */
        expenseType?: string;
        /**
         * 运单编号
         */
        carrierOrderCode?: string;
        /**
         * 子单号
         */
        subOrderNo?: string;
        /**
         * 装运单号
         */
        shipOrderNo?: string;
        /**
         * 原装运单号
         */
        relatedShipOrderNo?: string;
        originShipOrderNo?:string;
        /**
         * 交货单号
         */
        deliveryOrderNo?: string;
    
         customerBaseName?: string;
    
         customerBaseId?: string;
        /**
         * 发货时间
         */
        startDeliveryTime?: string;
        /**
         * 发货时间
         */
        endDeliveryTime?: string;
        /**
         * 车队名称
         */
        carrierName?: string;
        /**
         * 车队ID
         */
        carrierId?: string;
        asc?: boolean;

        orderBy?: string | number;
        /**
         * 跳过项
         */
        skip?: number;
        /**
         * 显示数
         */
        count?: number;
    }
    /**
     * 应收列表数据
     */
    export interface ReceivableListItemVM {
        index?: number;
        /**
       * 应收id
       */
      id?: string;
      status?: string;
      /**
       * 应收费用编号
       */
      code?: string | null;
      /**
       * 费用类型
       */
      expenseType?: string | null;
      /**
       * 费用金额
       */
      amount?: number | null;
      /**
       * 费用说明
       */
      expenseExplain?: string | null;
      /**
       * 运单号
       */
      carrierOrderCode?: string | null;
      /**
       * 子单号
       */
      subOrderNo?: string | null;
      /**
       * 装运单号
       */
      shipOrderNo?: string | null;
      /**
       * 原装运单号
       */
      relatedShipOrderNo?: string | null;
      /**
       * 交货单号
       */
      deliveryOrderNo?: string | null;
      /**
       * 发货方
       */
      shipperName?: string | null;
      /**
       * 车队名称
       */
      carrierName?: string | null;
      /**
       * 收货地址
       */
      arrivalAddress?: string | null;
      /**
       * 实际发货时间
       */
      realDeliveryTime?: string | null;
      /**
       * 实际送达时间
       */
      realArrivalTime?: string | null;
      carrierOrderStatus?: string;
      /**
       * 运单状态
       */
      carrierOrderStatusStr?: string | null;
      receiptStatus?: string;
      /**
       * 回单状态
       */
      receiptStatusStr?: string | null;
    };
    /**
* 编辑应收
*/
    export interface EditReceivableVM {
        /**
         * 费用类型
         */
        expenseType?: string | null;
        /**
         * 金额
         */
        amount?: number | null;
        /**
         * 费用说明
         */
        expenseExplain?: string | null;
    };
    /**
     * 保存账单
     */
    export interface SaveReceivableBillVM {
        /**
         * 添加的应收费用id集合
         */
        addReceivableIds?: string[] | null;
        /**
         * 账单id
         */
        billId?: string | null;
        /**
         * 删除的运单id集合
         */
        delCarrierOrderIds?: string[] | null;
        /**
         * 是否审核通过  true 审核通过  false null 执行保存
         */
        isAuditPass?: boolean | null;
    }
    /**
 * 添加应收账单费用
 */
    export interface AddReceivableBillExpenseVM {
        /**
         * 应收账单id
         */
        receivableBillId?: string | null;
        /**
         * 金额
         */
        amount?: number | string;
        /**
         * 费用类型
         */
        expenseType?: string | null;
        /**
         * 费用说明
         */
        expenseExplain?: string | null;
    };

    /**
 * 应收账单- 账单费用列表项
 */
    export interface ReceivableBillExpenseItemVM {
        id?: string;
        /**
         * 费用类型
         */
        expenseType?: string | null;
        /**
         * 金额
         */
        amount?: number | null;
        /**
         * 费用说明
         */
        expenseExplain?: string | null;
        /**
         * 创建人
         */
        creator?: string | null;
    };

    /**
 * 添加应收账单
 */
    export interface AddReceivableBillVM {
        /**
         * 发货方id
         */
         customerBaseId?: string | null;
        /**
         * 对账周期 
         */
        cycle?: string[] | null;
        /**
         * 预计收款日期
         */
        preCollectionDate?: string | null;
    };
    
    /**
     * 应收账单详情数据
     */
    export interface ReceivableBillDetailVM{
           /**
       * 应收账单id
       */
      id?: string;
      status?: string;
      /**
       * 账单编号
       */
      billCode?: string | null;
      /**
       * 对账周期
       */
      billCycle?: string | null;
      /**
       * 账单总金额
       */
      totalAmount?: number;
      /**
       * 含税金额
       */
      includeTaxAmount?: number;
      /**
       * 客诉金额
       */
      customerComplaintAmount?: number;
      /**
       * 其他金额
       */
      otherAmount?: number;
      /**
       * 客户基地id
       */
       customerBaseId?: string;
      /**
       * 客户基地
       */
       customerBaseName?: string | null;
      /**
       * 创建人名字
       */
      creator?: string | null;
      /**
       * 预计收款日期
       */
      preCollectionDate?: string;
    }
    /**
     * 账单列表查询
     */
    export interface GetReceivableBillListPayload {
        /**
         * 应收账单状态Available values : 0, 1, 2, 3
         */
        status?: string;
        /**
         * 账单编号
         */
        billCode?: string;
        /**
         * 对账周期
         */
        billCycle?: string;
        /**
         * 客户基地
         */
        customerBaseName?: string;
        customerBaseId?:string;
        creationStartTime?: string;

        creationEndTime?: string;

        asc?: boolean;

        orderBy?: string | number;

        skip?: number;

        count?: number
    }
    /**
     * 账单查询列表数据
     */
    export interface ReceivableBillListItemVM {
        index?: number;
        /**
         * 应收账单id
         */
        id?: string;
        /**
         * "0" | "1" | "2"
         */
        status?: string;
        /**
         * 账单编号
         */
        billCode?: string | null;
        /**
         * 对账周期
         */
        billCycle?: string | null;
        /**
         * 发货方
         */
        shipper?: string | null;
        /**
         * 账单总金额
         */
        totalAmount?: number;
        /**
         * 含税金额
         */
        includeTaxAmount?: number;
        /**
         * 客诉金额
         */
        customerComplaintAmount?: number;
        /**
         * 其他金额
         */
        otherAmount?: number;
        /**
         * 创建人
         */
        creator?: string | null;
        /**
         * 创建时间
         */
        creationTime?: string;
    };

    /**
     * 获取运单费用
     */
    export interface GetCarrierOrderListPayload{
        /**
         * 运单编号
         */
        carrierOrderCode?:string;
        /**
         * 运单状态
         */
        carrierOrderStatus?: number|string;
        /**
         * 回单状态
         */
        receiptStatus?: number|string;
        /**
         * 账单id
         */
        billId?: string;
        asc?:boolean;
        orderBy?:string;
        skip?:number;
        count?: number;
    }
}
